import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { onClickFilterSave, onClickFilterClear } from "../../redux/actions";
import FilterButtonForTableHeader from "../FilterButtonForTableHeader/FilterButtonForTableHeader";
import FilterPopUp from "../FilterPopUp/FilterPopUp";
import DateRangeFilter from "./DateRangeFilter";
import RIAFilter from "./RIAFilter";
import AdvisorFilter from "./AdvisorFilter";
import TypeFilter from "./TypeFilter";
import CustodianFilter from "./CustodianFilter";
import StatusFilter from "./StatusFilter";
import RefferFilter from "./RefferFilter";
import AumFilter from "./AumFilter";
import ROIFilter from "./ROIFilter";
import GainLossFilter from "./GainLossFilter";
import ClientTypeFilter from "./ClientTypeFilter";

const BodyWrapper = styled.div`
  max-height: 60vh;
  min-height: 60vh;
  overflow-y: scroll;
  width: 100%;

  &::-webkit-scrollbar {
    width: 10px;
    border: none;
  }

  /* @media (max-width: 1536px) {
    max-height: 44vh;
    min-height: 44vh;
  }

  @media (max-height: 937px) {
    max-height: 53vh;
    min-height: 53vh;
  } */

  //1536

  .table {
    border-collapse: separate;
    border-spacing: 0 1em;
    width: 100%;

    .tableHeader th {
      position: absolute;
      text-align: left;
      font-size: 12px;
      color: #004576;
      padding-left: 15px;
      cursor: pointer;
      position: sticky;
      top: 0;
      background-color: white;
    }

    .tableRow {
      font-size: 16px;
      padding-top: 17px;

      .clientName {
        color: #008ef2;
        cursor: pointer;
      }
    }

    .tableRow td:not(:last-child) {
      border-right: 1px solid rgba(0, 0, 0, 0.15);
      padding-left: 15px;
    }

    .tableRow td {
      padding-left: 15px;
    }
  }
`;

const ClientListTable = ({
  listOfAdvisors,
  handleScrollOnTable,
  handleClientNameClick,
  handleAdvisorNameClick,
  sortClientTable,
  filterApplied,
}) => {
  const { filterDataOnClientTable } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [clientNameSortingStatus, setClientNameSortingStatus] = useState(1);
  const [dateOpenSortingStatus, setDateOpenSortingStatus] = useState(0);
  const [aumSortingStatus, setAumSortingStatus] = useState(0);
  const [gainLossSortingStatus, setGainLossSortingStatus] = useState(0);
  const [roiSortingStatus, setRoiSortingStatus] = useState(0);
  const [typeSortingStatus, setTypeSortingStatus] = useState(0);
  const [statusSortingStatus, setStatusSortingStatus] = useState(0);
  const [referredSortingStatus, setReferredSortingStatus] = useState(0);
  const [clientTypeSortingStatus, setClientTypeSortingStatus] = useState(0);
  const [riaSortingStatus, setRiaSortingStatus] = useState(0);
  const [custodianSortingStatus, setCustodianSortingStatus] = useState(0);
  const [accountSortingStatus, setAccountSortingStatus] = useState(0);
  const [advisorSortingStatus, setAdvisorSortingStatus] = useState(0);
  const [isFilterPopupVisible, setIsFilterPopupVisible] = useState(false);
  const [currentFilterUi, setCurrentFilterUi] = useState(<></>);
  const [filterPopupLeft, setFilterPopupLeft] = useState(0);
  const [filterPopupTop, setFilterPopupTop] = useState(0);
  const [filterPopupHeaderName, setFilterPopupHeaderName] = useState("");

  const dateOpenedColumnHeader = useRef(null);
  const riaColumnHeader = useRef(null);
  const advisorColumnHeader = useRef(null);
  const typeColumnHeader = useRef(null);
  const custodianColumnHeader = useRef(null);
  const statusColumnHeader = useRef(null);
  const refferedColumnHeader = useRef(null);
  const aumColumnHeader = useRef(null);
  const roiColumnHeader = useRef(null);
  const gainLossColumnHeader = useRef(null);
  const clientTypeColumnHeader = useRef(null);

  const handleTableHeaderClick = (tableHeaderName) => {
    if (tableHeaderName === "clientName") {
      setClientNameSortingStatus(
        clientNameSortingStatus == 2 ? 0 : clientNameSortingStatus + 1
      );
      sortClientTable(
        "ClientName",
        clientNameSortingStatus == 2 ? 0 : clientNameSortingStatus + 1
      );
    } else if (tableHeaderName === "dateOpened") {
      setDateOpenSortingStatus(
        dateOpenSortingStatus == 2 ? 0 : dateOpenSortingStatus + 1
      );
      sortClientTable(
        "DateOpened",
        dateOpenSortingStatus == 2 ? 0 : dateOpenSortingStatus + 1
      );
    } else if (tableHeaderName === "aum") {
      setAumSortingStatus(aumSortingStatus == 2 ? 0 : aumSortingStatus + 1);
      sortClientTable("AUM", aumSortingStatus == 2 ? 0 : aumSortingStatus + 1);
    } else if (tableHeaderName === "gainLoss") {
      setGainLossSortingStatus(
        gainLossSortingStatus == 2 ? 0 : gainLossSortingStatus + 1
      );
      sortClientTable(
        "GainLoss",
        gainLossSortingStatus == 2 ? 0 : gainLossSortingStatus + 1
      );
    } else if (tableHeaderName === "roi") {
      setRoiSortingStatus(roiSortingStatus == 2 ? 0 : roiSortingStatus + 1);
      sortClientTable("ROI", roiSortingStatus == 2 ? 0 : roiSortingStatus + 1);
    } else if (tableHeaderName === "type") {
      setTypeSortingStatus(typeSortingStatus == 2 ? 0 : typeSortingStatus + 1);
      sortClientTable(
        "Type",
        typeSortingStatus == 2 ? 0 : typeSortingStatus + 1
      );
    } else if (tableHeaderName === "ria") {
      setRiaSortingStatus(riaSortingStatus == 2 ? 0 : riaSortingStatus + 1);
      sortClientTable("Ria", riaSortingStatus == 2 ? 0 : riaSortingStatus + 1);
    } else if (tableHeaderName === "clientType") {
      setClientTypeSortingStatus(
        clientTypeSortingStatus == 2 ? 0 : clientTypeSortingStatus + 1
      );
      sortClientTable(
        "ClientType",
        clientTypeSortingStatus == 2 ? 0 : clientTypeSortingStatus + 1
      );
    } else if (tableHeaderName === "status") {
      setStatusSortingStatus(
        statusSortingStatus == 2 ? 0 : statusSortingStatus + 1
      );
      sortClientTable(
        "Status",
        statusSortingStatus == 2 ? 0 : statusSortingStatus + 1
      );
    } else if (tableHeaderName === "referred") {
      setReferredSortingStatus(
        referredSortingStatus == 2 ? 0 : referredSortingStatus + 1
      );
      sortClientTable(
        "Referred",
        referredSortingStatus == 2 ? 0 : referredSortingStatus + 1
      );
    } else if (tableHeaderName === "custodian") {
      setCustodianSortingStatus(
        custodianSortingStatus == 2 ? 0 : custodianSortingStatus + 1
      );
      sortClientTable(
        "Custodian",
        custodianSortingStatus == 2 ? 0 : custodianSortingStatus + 1
      );
    } else if (tableHeaderName === "account") {
      setAccountSortingStatus(
        accountSortingStatus == 2 ? 0 : accountSortingStatus + 1
      );
      sortClientTable(
        "AccountId",
        accountSortingStatus == 2 ? 0 : accountSortingStatus + 1
      );
    } else if (tableHeaderName === "advisor") {
      setAdvisorSortingStatus(
        advisorSortingStatus == 2 ? 0 : advisorSortingStatus + 1
      );
      sortClientTable(
        "Advisor",
        advisorSortingStatus == 2 ? 0 : advisorSortingStatus + 1
      );
    }
  };

  const handleFilterClick = (headerName) => {
    setIsFilterPopupVisible(true);
    if (headerName === "dateOpened") {
      setCurrentFilterUi(<DateRangeFilter />);
      setFilterPopupLeft(dateOpenedColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        dateOpenedColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Date Range");
    } else if (headerName === "aum") {
      setCurrentFilterUi(<AumFilter />);
      setFilterPopupLeft(aumColumnHeader.current.offsetLeft + 100);
      setFilterPopupHeaderName("AUM Range");
      setFilterPopupTop(
        aumColumnHeader.current.getBoundingClientRect().top + 30
      );
    } else if (headerName === "gainLoss") {
      setCurrentFilterUi(<GainLossFilter />);
      setFilterPopupLeft(gainLossColumnHeader.current.offsetLeft + 100);
      setFilterPopupHeaderName("Gain/Loss");
      setFilterPopupTop(
        gainLossColumnHeader.current.getBoundingClientRect().top + 30
      );
    } else if (headerName === "roi") {
      setCurrentFilterUi(<ROIFilter />);
      setFilterPopupLeft(roiColumnHeader.current.offsetLeft + 100);
      setFilterPopupHeaderName("ROI");
      setFilterPopupTop(
        roiColumnHeader.current.getBoundingClientRect().top + 30
      );
    } else if (headerName === "ria") {
      setCurrentFilterUi(<RIAFilter />);
      setFilterPopupLeft(riaColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        riaColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("RIA");
    } else if (headerName === "advisor") {
      setCurrentFilterUi(<AdvisorFilter />);
      setFilterPopupLeft(advisorColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        advisorColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Advisor");
    } else if (headerName === "type") {
      setCurrentFilterUi(<TypeFilter />);
      setFilterPopupLeft(typeColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        typeColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Account Type");
    } else if (headerName === "custodian") {
      setCurrentFilterUi(<CustodianFilter />);
      setFilterPopupLeft(custodianColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        custodianColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Custodian");
    } else if (headerName === "clientType") {
      setCurrentFilterUi(<ClientTypeFilter />);
      setFilterPopupLeft(
        window.innerWidth < 1700
          ? clientTypeColumnHeader.current.offsetLeft - 100
          : clientTypeColumnHeader.current.offsetLeft
      );
      setFilterPopupTop(
        clientTypeColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Client Type");
    } else if (headerName === "Referred") {
      setCurrentFilterUi(<RefferFilter />);
      setFilterPopupLeft(
        window.innerWidth <= 1700
          ? refferedColumnHeader.current.offsetLeft - 180
          : refferedColumnHeader.current.offsetLeft - 130
      );
      setFilterPopupTop(
        refferedColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Referred");
    } else if (headerName === "status") {
      setCurrentFilterUi(<StatusFilter />);
      setFilterPopupLeft(
        window.innerWidth <= 1700
          ? statusColumnHeader.current.offsetLeft - 180
          : statusColumnHeader.current.offsetLeft - 130
      );
      setFilterPopupTop(
        statusColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Status");
    }
  };

  const handleFilterPopupCrossButtonClick = () => {
    setIsFilterPopupVisible(false);
  };

  const handleFilterPopupClearClick = () => {
    dispatch(onClickFilterClear(filterPopupHeaderName));
  };

  const handleFilterPopupSaveClick = () => {
    dispatch(onClickFilterSave(filterPopupHeaderName));
    filterApplied();
    // setIsFilterPopupVisible(false);
  };

  useEffect(() => {
    setIsFilterPopupVisible(false);
  }, [filterDataOnClientTable]);

  const isColumnFiltered = (column) => {
    return filterDataOnClientTable.find((data) => data.columnName === column);
  };

  return (
    <BodyWrapper onScroll={handleScrollOnTable}>
      {isFilterPopupVisible && (
        <FilterPopUp
          filterField={filterPopupHeaderName}
          left={filterPopupLeft}
          top={filterPopupTop}
          crossButtonClick={handleFilterPopupCrossButtonClick}
          clearClick={handleFilterPopupClearClick}
          saveClick={handleFilterPopupSaveClick}
        >
          {currentFilterUi}
        </FilterPopUp>
      )}
      <table className="table">
        <tr className="tableHeader">
          <th onClick={() => handleTableHeaderClick("clientName")}>
            Client Name
            <div style={{ paddingLeft: "25px" }}>
              {clientNameSortingStatus == 1 ? (
                <FontAwesomeIcon icon={faChevronDown} />
              ) : clientNameSortingStatus == 2 ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <span>&nbsp;</span>
              )}
            </div>
          </th>
          <th onClick={() => handleTableHeaderClick("account")}>
            Account #
            <div style={{ paddingLeft: "20px" }}>
              {accountSortingStatus == 1 ? (
                <FontAwesomeIcon icon={faChevronDown} />
              ) : accountSortingStatus == 2 ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <span>&nbsp;</span>
              )}
            </div>
          </th>
          <th ref={dateOpenedColumnHeader}>
            <span onClick={() => handleTableHeaderClick("dateOpened")}>
              Date Opened
            </span>
            <FilterButtonForTableHeader
              isColumnFiltered={isColumnFiltered("DateOpened")}
              handleOnClick={() => handleFilterClick("dateOpened")}
            />
            <div style={{ paddingLeft: "28px" }}>
              {dateOpenSortingStatus == 1 ? (
                <FontAwesomeIcon icon={faChevronDown} />
              ) : dateOpenSortingStatus == 2 ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <span>&nbsp;</span>
              )}
            </div>
          </th>
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].aum !== undefined)) && (
            <th ref={aumColumnHeader}>
              <span onClick={() => handleTableHeaderClick("aum")}>AUM</span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("AUM Range")}
                handleOnClick={() => handleFilterClick("aum")}
              />
              <div style={{ paddingLeft: "6px" }}>
                {aumSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : aumSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].gainLoss !== undefined)) && (
            <th ref={gainLossColumnHeader}>
              <span onClick={() => handleTableHeaderClick("gainLoss")}>
                Gain/Loss
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("GainLoss")}
                handleOnClick={() => handleFilterClick("gainLoss")}
              />{" "}
              <div style={{ paddingLeft: "20px" }}>
                {gainLossSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : gainLossSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].roi !== undefined)) && (
            <th ref={roiColumnHeader}>
              <span onClick={() => handleTableHeaderClick("roi")}>ROI</span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("ROI")}
                handleOnClick={() => handleFilterClick("roi")}
              />
              <div style={{ paddingLeft: "4px" }}>
                {roiSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : roiSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].riaName !== undefined)) && (
            <th ref={riaColumnHeader}>
              <span onClick={() => handleTableHeaderClick("ria")}>RIA</span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("RIA")}
                handleOnClick={() => handleFilterClick("ria")}
              />
              <div style={{ paddingLeft: "4px" }}>
                {riaSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : riaSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].advisorName !== undefined)) && (
            <th ref={advisorColumnHeader}>
              <span onClick={() => handleTableHeaderClick("advisor")}>
                Advisor
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Advisor")}
                handleOnClick={() => handleFilterClick("advisor")}
              />
              <div style={{ paddingLeft: "15px" }}>
                {advisorSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : advisorSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].accountType !== undefined)) && (
            <th ref={typeColumnHeader}>
              <span onClick={() => handleTableHeaderClick("type")}>
                Account Type
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Type")}
                handleOnClick={() => handleFilterClick("type")}
              />
              <div style={{ paddingLeft: "28px" }}>
                {typeSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : typeSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].custodianName !== undefined)) && (
            <th ref={custodianColumnHeader}>
              <span onClick={() => handleTableHeaderClick("custodian")}>
                Custodian
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Custodian")}
                handleOnClick={() => handleFilterClick("custodian")}
              />
              <div style={{ paddingLeft: "20px" }}>
                {custodianSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : custodianSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].clientType !== undefined)) && (
            <th ref={clientTypeColumnHeader}>
              <span onClick={() => handleTableHeaderClick("clientType")}>
                Client Type
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("ClientType")}
                handleOnClick={() => handleFilterClick("clientType")}
              />
              <div style={{ paddingLeft: "25px" }}>
                {clientTypeSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : clientTypeSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].referred !== undefined)) && (
            <th ref={refferedColumnHeader}>
              <span onClick={() => handleTableHeaderClick("referred")}>
                Referred
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Referred")}
                handleOnClick={() => handleFilterClick("Referred")}
              />
              <div style={{ paddingLeft: "20px" }}>
                {referredSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : referredSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].status !== undefined)) && (
            <th ref={statusColumnHeader}>
              <span onClick={() => handleTableHeaderClick("status")}>
                Status
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Status")}
                handleOnClick={() => handleFilterClick("status")}
              />
              <div style={{ paddingLeft: "10px" }}>
                {statusSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : statusSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
        </tr>
        {listOfAdvisors &&
          listOfAdvisors?.length > 0 &&
          listOfAdvisors?.map((data) => (
            <tr className="tableRow">
              <td
                onClick={() =>
                  handleClientNameClick(data.clientId, data?.externalId)
                }
                className="clientName"
              >
                {data?.clientName}
              </td>
              <td>{data?.externalId}</td>
              <td>{new Date(data?.dateOpened).toDateString()}</td>
              {data?.aum !== undefined && (
                <td>
                  $
                  {parseFloat(data?.aum)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </td>
              )}
              {data?.gainLoss !== undefined && (
                <td>
                  {parseFloat(data?.gainLoss) < 0
                    ? "-$" +
                      parseFloat(data?.gainLoss * -1)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : "$" +
                      parseFloat(data?.gainLoss)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </td>
              )}
              {data?.roi !== undefined && (
                <td>{parseFloat(data?.roi).toFixed(2)}%</td>
              )}
              {data?.riaName !== undefined && <td>{data?.riaName}</td>}
              {data?.advisorName !== undefined && (
                <td
                  onClick={() => handleAdvisorNameClick(data.advisorId)}
                  className="clientName"
                >
                  {data?.advisorName}
                </td>
              )}
              {data?.accountType !== undefined && <td>{data?.accountType}</td>}
              {data?.custodianName !== undefined && (
                <td>{data?.custodianName}</td>
              )}
              {data?.status !== undefined && <td>{data?.clientType}</td>}
              {data?.referred !== undefined && <td>{data?.referred}</td>}
              {data?.status !== undefined && <td>{data?.status}</td>}
            </tr>
          ))}
      </table>
    </BodyWrapper>
  );
};

export default ClientListTable;
